

import React from "react";
import "./css/Home.css";
import "./css/Header.css";
import ProjectCard from "./ProjectCard";
import { useProjectsWithLikes } from "../../hooks/useProjectsWithLikes";

const urls = {
  github: "https://github.com/jamescer",
  linkedin: "https://linkedin.com/in/jamescerniglia",
  twitter: "https://twitter.com/jamescerniglia"
};



const Projects = () => {
  const projects = useProjectsWithLikes();
  const projectsShown = projects.map((project1) => (
    <ProjectCard key={project1.id} project={project1} />
  ));

  return (
    <main className="os-main">
      <section className="os-projects-container">
        <h4 className="os-projects-title">Projects</h4>
        <div className="os-projects-row">
          {projectsShown}
        </div>
      </section>
    </main>
  );
};

export default Projects;
